import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [
    'modal',
    'modalContent',
    'incompleteTemplate',
    'progress',
    'progressTemplate',
  ];

  get authParam() {
    return document
      .querySelector('meta[name="csrf-param"]')
      .getAttribute('content');
  }

  get authToken() {
    return document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute('content');
  }

  get conversationComplete() {
    return this.data.get('conversation-complete') === 'true';
  }

  get uploadPath() {
    return this.data.get('path');
  }

  get modalController() {
    return this.application.getControllerForElementAndIdentifier(
      this.modalTarget,
      'modal'
    );
  }

  confirmIncomplete() {
    this._uploadConversation();
  }

  upload() {
    if (this.conversationComplete) {
      this._uploadConversation();
    } else {
      this._showIncompleteConversationPrompt();
    }

    this.modalController.open();
  }

  _showIncompleteConversationPrompt() {
    this._updateModalContent(this.incompleteTemplateTarget.innerHTML);
  }

  _updateModalContent(html) {
    const fragment = document.createRange().createContextualFragment(html);
    this.modalContentTarget.replaceChildren();
    this.modalContentTarget.appendChild(fragment);
  }

  _uploadConversation() {
    this._updateModalContent(this.progressTemplateTarget.innerHTML);

    const init = {
      method: 'POST',
      body: JSON.stringify({ [this.authParam]: this.authToken }),
      headers: {
        'Content-Type': 'application/json',
      },
    };

    fetch(this.uploadPath, init)
      .then(response => response.text())
      .then(html => this._updateModalContent(html));
  }
}
